// libraries
import React from "react";

// styles
import styles from "./styles.module.scss";

const Wrap = ({
  icon,
  label,
  value,
  placeholder,
  locations,
  toggleModal,
  children,
}) => {
  return (
    <div
      className={`${styles.wrap} ${label === "Price" ? styles.no_border : ""} ${
        label === "Select Date" ? styles.no_padding_top : ""
      }`}
      onClick={() =>
        toggleModal(
          label === "Select Date"
            ? "starts"
            : label === "Virtual"
            ? "virtual"
            : label === "Virtual Link"
            ? "link"
            : label === "Category"
            ? "category"
            : label === "Select Time"
            ? "duration"
            : label === "Location"
            ? "location"
            : label === "Reoccurring Event"
            ? "reoccurring"
            : "price"
        )
      }
    >
      <div className={styles.main}>
        <span>
          {icon}
          <p>{label}</p>
        </span>
        <span className={value ? "" : styles.placeholder}>
          {value ? value : placeholder}
        </span>
      </div>
      {locations && (
        <div className={styles.locations}>
          <span>
            {locations.map((item, index) => (
              <span className={styles.location} key={index}>
                {item}
              </span>
            ))}
          </span>
        </div>
      )}
      {children && (
        <div
          onClick={(e) => {
            e.stopPropagation();
            toggleModal(null);
          }}
          className={styles.children}
        >
          {children}
        </div>
      )}
    </div>
  );
};

export default Wrap;
